module.exports = __webpack_public_path__ + "img/LOGO-2.f5d0ea55.png";